import { render, staticRenderFns } from "./GenerateStudentInvoiceModal.vue?vue&type=template&id=56976f1a"
import script from "./GenerateStudentInvoiceModal.vue?vue&type=script&lang=ts"
export * from "./GenerateStudentInvoiceModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports